const doc = [({"da":({"js":({"admin":({"highscore_regions":({"table":({"the_region_was_removed_from_the_highscore":"Regionen blev fjernet fra highscoren"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;